import Http from './http'

const BASE_URL = "/api/user"

export default {
  async dict(opt) {
    return Http.get(`${BASE_URL}/dict`, opt)
  },
  async index(opt) {
    return Http.get(`${BASE_URL}/index`, opt)
  },
  async userIndex(opt) {
    return Http.get(`${BASE_URL}/index?searchType=1`, opt)
  },
  async info(query) {
    return Http.get(`${BASE_URL}/info`,query)
  },
  async userListNoPage(query) {
    return Http.get(`${BASE_URL}/userList`,query)
  },
  async get(id) {
    return Http.get(`${BASE_URL}/get`, {id: id})
  },
  async post(data) {
    return Http.post(`${BASE_URL}/post`, data)
  },
  async del(id) {
    return Http.post(`${BASE_URL}/del`, undefined, {id: id})
  },
  async items(type) {
    return Http.get(`${BASE_URL}/items`, {type: type})
  },
  async search(lng, lat, radius) {
    return Http.get(`${BASE_URL}/search`, {lng: lng, lat: lat, radius: radius})
  },
  async searchPJ(lng, lat, radius) {
    return Http.get(`${BASE_URL}/searchPJ`, {lng: lng, lat: lat, radius: radius})
  },
  async searchUnitPJ(opt) {
    return Http.get(`${BASE_URL}/searchUnitPJ`, opt)
  },
  async onlineUnits(opt) {
    return Http.get(`${BASE_URL}/online-units`, opt)
  },
  async onlineUsers(opt) {
    return Http.get(`${BASE_URL}/online-users`, opt)
  },
  async getPosition(id) {
    return Http.get(`${BASE_URL}/get-position`, {id: id})
  },
  async updatePosition(data) {
    return Http.post(`${BASE_URL}/update-position`, data)
  },
  async resetPassword(id) {
    return Http.post(`${BASE_URL}/reset-password`, undefined, {id})
  },
  async notify(alertId) {
    return Http.get(`${BASE_URL}/notify`, {alertId})
  },
  async getOnlineClients(opt) {
    return Http.get(`${BASE_URL}/get-online-clients`,opt)
  },
}




// WEBPACK FOOTER //
// ./src/api/user.js